(function () {
    angular
    .module('pgtocobrancas', []);  
})();
